import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import connect from 'dojo/_base/connect';
import domConstruct from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import on from 'dojo/on';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import OccurrenceFilters from './OccurrenceFilters';
import OccurrenceFormDialog from './OccurrenceFormDialog';
import template from './OccurrenceHome.html?raw';
// Template-only widget (used via data-dojo-type in OccurrenceHome.html, not as a value in code) → bare import.
import "./OccurrenceList";
// NOTE (JS2TS): dropped dead dep WidgetCollection/JDM/Occurrence/OccurrenceOfflineManager (imported but never used in code and not in the template).
// xstyle/css!./OccurrenceHome.css was already commented out.

class OccurrenceHome extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;
    isEditor = false;
    occurrenceDialog: any = null;
    //occurrenceList: null, // ist schon im Template
    _submitInProgess = false;
    employee: any = null;
    Filtermode = "";//"MyOccurrences",
    filterPresets: any = null;
    //  _occurrenceFiltersInitialized: false,
    genericDialog: any = null;
    started = false;
    online = true;

    _ldapSubstitionChanging = false;





    startup(): void {

        //this.inherited(arguments);
        console.log("Home Startup");
        sessionStorage.removeItem("currentEmployee");

        var title = this.translations["OccurrenceHome__MainTitle"];
        if (title == "" || title == null || typeof (title) == "undefined") {
            title = "ekus Meldewesen";
        }
        document.title = title;
        (document as any).occurrenceHome = this;

        var topBarTitle = document.getElementById("topBarTitle");
        if (topBarTitle) {
            domAttr.set(topBarTitle, "innerHTML", title);
        }


        this.occurrenceList.homePanel = this;
        //this.occurrenceList.on("requestList", lang.hitch(this, this._onListRequest));
        this.occurrenceList.startup();


        this.checkSiteAction();

        this.started = true;
    }

    //startup ---------------------------------------------------------------------

    checkSiteAction(): void {

        var paramNames: any = this.getUrlParameterNames();

        if (paramNames != false) {
            for (var i = 0; i < paramNames.length; i++) {
                var param = paramNames[i];
                var value = this.getUrlParameterValue(param);

                if (value != false) {
                    switch (param.toUpperCase()) {
                        case "VIEW":
                            // Kommentar auch gewünscht?
                            var commentId = this.getUrlParameterValue("qa");

                            if (commentId != false) {
                                this.showOccurrenceDialog(value, null, commentId);
                            } else {
                                this.showOccurrenceDialog(value, null); // Schreibschutz wird
                            }

                            return; // RAUS
                            break;

                        case "CREATE":

                            var dlg = this.showOccurrenceDialog();
                            dlg.occurrenceForm.inputOccurrenceType.selectedValue = value;
                            return;
                            break;

                        case "RATE":
                            this.startRating((window as any).entityId); // JS2TS: `entityId` is undefined here in the original (never declared/imported) — preserved as a latent bug.
                            return;
                            break;

                        default:
                            //alert(this.translations["OccurrenceHome__ErrorDialog_InvalidURLParams"]);
                            break;

                    }
                } else {
                    this.removeUrlParameter(param);
                }
            }
        }
    }

    _sessionEstablished(substitutionID?: any): void {
        if (this.started)
            this._getCurrentEmployee(substitutionID);
    }

    // handler befüllt inputLocation, ref_lastlocation
    _getCurrentEmployee(substitutionID?: any): void {

        let employee = null;

        try {
            // substitution?
            if ((window as any).occurrenceSubstitution) {
                employee = (window as any).occurrenceSubstitution.entity;
            }
            else {
                let employeeTXT = sessionStorage.getItem("currentEmployee");
                if (typeof (employeeTXT) == "object") {
                    employee = employeeTXT;
                } else {
                    employee = JSON.parse(employeeTXT);
                }
                if (employee && (window as any).sessionInfo) {
                    if ((window as any).sessionInfo.sessionData.CurrentEmployeeId != employee.ID) {
                        employee = null;
                    }
                } else {
                    employee = null;
                }
            }
        } catch (ex) {
            employee = null;
        }

        //CurrentEmployee zuweisen
        if (employee != null) {
            if (substitutionID) {
                employee.ldapSubstitutionId = substitutionID;
            }
            this._onGetCurrentEmployeeResponse(employee);
            return;
        }

        this.StandbyStart();
        var url = window.appRoot + "JDM/GetCurrentEmployeeJSON";

        this.RequestManager.post(
            url,
            {},
            lang.hitch(this, "_onGetCurrentEmployeeResponse"),
            lang.hitch(this, function (error: any) {
                console.error("current employee fehler", error.Message);
            }),
            false // sync
        );
    }


    _onGetCurrentEmployeeResponse(response: any): void {
        this.StandbyStop();
        this.employee = response;
        let bIsEditor = false;


        console.log("occurrenceHome currentEmployee", this.employee);

        sessionStorage.setItem("currentEmployee", JSON.stringify(response));

        if (this.occurrenceDialog != null) {
            this.occurrenceDialog.set("Employee", this.employee);
        }

        /*  if (this.employee != null) {


          }*/

        if (this.employee.Classname == "Employee" ||
            this.employee.Classname == "Employee_LDAPgroup") {
            if (!this.employee.ref_last_location) {
                let dialog: any = new GenericDialog();

                dialog.hideSubtitleNode();
                domStyle.set(dialog.textNode, "height", "unset");

                dialog.set("header", "Kein Standort hinterlegt");

                dialog.set("content", "Bitte wählen Sie Ihren aktuellen Standort aus, um alle Funktionen nutzen zu können.");

                dialog.set("callback", lang.hitch(this, this.highlightEmployeeLocation));
                dialog.set("ok", true);
                dialog.show();
            }
        }
        if (this.employee != null) {
            // prüfen ob der employee zu einer Bearbeiter-Gruppe gehört
            if (this.employee != null) {
                for (var i = 0; i < this.employee.groupList.length; i++) {
                    var group = this.employee.groupList[i];
                    if (group.is_occurrence_group == true) {
                        this.occurrenceList._isEditor = true;
                        bIsEditor = true;
                        break;
                    }
                }
                this.isEditor = bIsEditor;

                let isExternal = this.employee.Classname == "Contact_person";
                domClass.toggle(this.locationContainer, "w3-hide", isExternal);
                domClass.toggle(this.substitutionContainer, "w3-hide", this.employee.Classname != "Employee_LDAPgroup" && (isExternal || !this.inputSubstitution?.entities?.count));
                domClass.toggle(this.substitutionContainer, "highlightContainer", this.employee.Classname == "Employee_LDAPgroup");

                //   this.createFilter();
                if (!(window as any).occurrenceSubstitution) {

                    this.inputLocation._loadListValues(this.employee.ref_last_location, true); //  suppress change!
                    if (!isExternal) {
                        this.inputSubstitution._loadListValues(); // not suppress change!
                    }
                } else {
                    if (!isExternal) {
                        this.inputLocation.set("value", this.employee.ref_last_location, true);
                    }
                }
            }
        }

        this.createFilter();


    }


    //----------------------------------------------------------------------startup


    //filterpanel -----------------------------------------------------------------

    createFilter(): void {
        //  this.startup(this);

        this.occurrenceFilters = new OccurrenceFilters();
        this.occurrenceFilters.startup(this);
        this.occurrenceFilters.placeAt(this.editorFiltercontainer, "only");

        this.occurrenceFilters.on("changed", lang.hitch(this, this.onChangedFilters));
        this.occurrenceFilters.on("setup", lang.hitch(this, this.disableNode, this.listContainer));


        this.tryfilterSetup();
    }

    onChangedFilters(): void {
        this.applyFilters(0);
    }

    applyFilters(offset?: any, countLimit?: any): void {
        //console.log("apply filters", this._startupState, offset, countLimit);
        if (this._searchTimeout != null) {
            clearTimeout(this._searchTimeout);
            this._searchTimeout = null;
        }

        if (this._filterSettingsRequest != null) {
            // falls Filtersettings gerade noch geladen werden: Auf Antwort warten, dann löst dessen Response eh ein Pushstep inklusive applyFilters auf wenn der Rest passt
            return;
        }

        this._startupState = "ready";
        //this.StandbyStart();
        this.disableNode(this.sectionFilter, false);

        if (typeof (countLimit) != "number") {
            countLimit = this.occurrenceList._maxResponseCount;
        }
        if (typeof (offset) != "number") {
            offset = 0;
        }

        // Filterparameter in Objekt zusammenstellen

        let filterParams = this.occurrenceFilters._getSerializedFilterParams();

        filterParams._countLimit = countLimit;
        filterParams._offset = offset;

        //var strFilterParams = JSON.stringify(filterParams);
        //if (this._filterParams == strFilterParams) {
        //    //console.debug("apply filters: no change, list will not reload");
        //    return;
        //} else {
        //    this._filterParams = strFilterParams;
        //    console.debug("apply filters and load list");
        //}

        let stringParams = JSON.stringify(filterParams);
        if (this._lastRequestParameters == stringParams) {
            console.warn("duplicate request from filter!", filterParams);
            return;
        }

        //console.debug("filter: load list", filterParams);

        if (this._request != null) {
            this._request.cancel();
            this.StandbyStop();
        }

        this._lastRequestParameters = stringParams;

        domAttr.set(this.occurrenceList.loadMessage, "innerHTML", "lädt...");
        this.occurrenceList.StandbyStart();

        var url = window.appRoot + "JDM/LoadOccurrenceListJSON";

        this._request = this.RequestManager.post(
            url,
            {
                sJsonData: stringParams,
                mode: this.occurrenceFilters.filtermode//"OccurrenceEdit",
            },
            lang.hitch(this, "_onLoadOccurrencesResponse", offset, stringParams),
            lang.hitch(this, "_onLoadOccurrencesError"),
            false // sync
        );
    }

    _onLoadOccurrencesResponse(offset: any, stringParams: any, response?: any): void {
        //this.StandbyStop();

        this.emit("dataLoaded");

        this._filterresult = response;//JSON.parse(response);

        this.drawList(offset, response);
    }

    _onLoadOccurrencesError(error: any): void {
        this.StandbyStop();
        this.occurrenceList.StandbyStop();
        alert("Loading failed - please try again\r\n" + error.Message);
        console.error("_onLoadOccurrencesError", error.Message);
    }

    _onListLoadRequest(params: any): void {
        this.applyFilters(params.offset, params.count);
    }

    drawList(offset: any, list?: any): void {
        if (this.occurrenceList == null) {
            return;
        }

        if (offset > 0) {
            this.occurrenceList._onLoadAddedOccurrencesResponse(this._filterresult, offset);
        } else {
            this.occurrenceList._onLoadOccurrencesResponse(this._filterresult);
        }

        this.disableNode(this.listContainer, false);
    }



    _onFilterDataLoaded(): void {
        this._ldapSubstitionChanging = false; // LDAP-Umschaltung ist hier auf jeden Fall mal abgeschlossen und alles geladen
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);


    }

    highlightEmployeeLocation(): void {
        domClass.add(this.inputLocation.domNode.parentElement.parentElement, "highlightContainer");
        this.locationContainer.scrollIntoView();
    }



    _onLoadOccurrenceError(error: any): void {
        this.StandbyStop();
        var message = this.translations["OccurrenceHome__ErrorDialog_HeaderOccurrenceLoad"];
        this.showMessage(message, error.message);
        //alert(error.message);
    }

    showRatingDialog(entity?: any): void {
        this.StandbyStop();
        var dlg: any = new (window as any).RatingDialog(); // JS2TS: `RatingDialog` is undefined here in the original (never imported) — preserved as a latent bug.
        dlg.set("entity", entity, "evaluation_occurrence", "note_evaluation");
        dlg.set("callback", lang.hitch(this, "ratingDialogCallback"));

        dlg.startup();
    }

    ratingDialogCallback(): void {
        this.removeUrlParameter("rate");
    }


    _onSetLocation(suppressResponse?: any): void {
        if (this.employee) {
            let tmp = this.inputLocation.get("value");
            if (this.employee.ref_last_location != tmp) {
                this.employee.ref_last_location = tmp;
                this.tryfilterSetup();
            }
        }
    }

    _onChangeLocation(value?: any): void {
        //console.log("Location geändert", value);
        var additionalFct = lang.hitch(this, "_onSetLocation");

        domClass.remove(this.inputLocation.domNode.parentElement.parentElement, "highlightContainer");

        this._saveUserSettings(additionalFct);
    }

    _onChangeSubstitution(value?: any): void {
        //console.log("Subst geändert", value);

        //   if (this.occurrenceFilters != null) {
        //      this.occurrenceFilters.set("ldapsubstitution", this.inputSubstitution.get("value"));
        //      var additionalFct = lang.hitch(this, "_onSetSubstitution");

        this._handleLDAPSubstitution();

        this.disableNode(this.listContainer);
        this.disableNode(this.sectionFilter);

    }

    _onLoadedSubstitutions(entities?: any): void {
        let bShowSubstitutions = !(!entities?.length || this.isExternal);

        if (bShowSubstitutions) {

            //console.debug("substitutions loaded", entities, this.employee);

            if (this.employee && this.employee.ldapSubstitutionId) {
                this.inputSubstitution.set("value", this.employee.ldapSubstitutionId);
            }
        }
        this.hideNode(this.substitutionContainer, !bShowSubstitutions);
    }


    _handleLDAPSubstitution(): void {
        let originalEmployee = this.employee;

        if ((window as any).occurrenceSubstitution?.originalEmployee) {
            originalEmployee = { ...(window as any).occurrenceSubstitution.originalEmployee };
        }

        (window as any).occurrenceSubstitution = null;
        this.hideNode(this.sectionSubstitution, true);

        let substitutionEntity = this.inputSubstitution.get("value");

        // console.debug("_handleLDAPSubstitution", substitutionEntity);

        this._ldapSubstitionChanging = true;

        if (substitutionEntity) {
            // bin das ich selber?
            if (substitutionEntity.ID == (window as any).sessionInfo.sessionData.CurrentEmployeeId_Origin) {
                (window as any).occurrenceSubstitution = null;
            }
            else {
                let label = this.inputSubstitution.get("label");

                (window as any).occurrenceSubstitution = {
                    ID: substitutionEntity.ID,
                    entity: substitutionEntity,
                    label: label,
                    originalEmployee: originalEmployee
                };
            }
            if (this.employee != null) { // falls gerade der Editor-Filtertab angezeigt wird: Location umschalten auf "null"
                this._sessionEstablished();
            }
        }
        else {
            //console.log("keine Substitution");
            this.employee = originalEmployee;
            this.employee.ldapSubstitutionId = null;
            this._onGetCurrentEmployeeResponse(this.employee);
        }


        /*if (window.occurrenceSubstitution) {
            this.hideNode(this.sectionSubstitution, false);
            domAttr.set(this.sectionSubstitution, "innerHTML", this.translations["TaskApproval__SubstitutionActiveMessage"].format(window.taskApprovalSubstitution.label));
        }*/

        domClass.toggle(this.domNode, "w3-pale-yellow", !!(window as any).occurrenceSubstitution);

        this.saveLdapSubstitution();
    }

    saveLdapSubstitution(): void {
        let url = window.appRoot + "Occurrence/SaveLdapSubstitutionSetting";

        let data = {
            selectedSubstitution: (window as any).occurrenceSubstitution
        };

        this.RequestManager.callfunction(
            "Webtool_Occurrence_API__SaveLDAPsubstitutionSetting",
            data,
            lang.hitch(this, "_onSaveLdapSubstitutionSettingResponse"),
            lang.hitch(this, "_onSaveLdapSubstitutionSettingError")
        );

        this.disableNode(this.sectionSubstitution);
    }

    _onSaveLdapSubstitutionSettingResponse(): void {
        //
        this.disableNode(this.sectionSubstitution, false);
    }

    _onSaveLdapSubstitutionSettingError(error: any): void {
        //
        this.disableNode(this.sectionSubstitution, false);

        if (this.hasUserRole("_DEV")) {
            alert("saving ldap subsitution failed: " + error.Message);
        }
    }

    _onChangeLimitMailsToLocation(): void {
        this._saveUserSettings();
    }

    _saveUserSettings(callback?: any): void {
        this.StandbyStart(this.locationContainer);

        var jsonData = {
            location: this.inputLocation.get("value"),
            isLimitMailsToLocation: this.inputLimitMailsToLocation.checked == true,
            ldapsubstitution: this.inputSubstitution.get("value")
        };

        var url = window.appRoot + "Occurrence/SaveUserSettings";

        this.RequestManager.callfunction(
            "Webtool_Occurrence_API__SaveUserSettings",
            jsonData,
            lang.hitch(this, "_onSaveUserSettingsResponse", callback),
            lang.hitch(this, "_onSaveUserSettingsError"),
            true // commit
        );
    }

    _onSaveUserSettingsResponse(callback: any, response?: any): void {
        this.StandbyStop();

        if (typeof (callback) == "function") {
            callback();
        }

    }


    _filterSetupTimeout: any = null;

    tryfilterSetup(): void {
        //console.debug("tryfilterSetup");
        if (this._filterSetupTimeout != null) {
            clearTimeout(this._filterSetupTimeout);
            this._filterSetupTimeout = null;
        }

        if (this.employee != null) {
            this._filterSetupTimeout = setTimeout(lang.hitch(this, function () {
                this.disableNode(this.sectionFilter, false);
                this.occurrenceFilters.setup(this.employee);
            }), 222);
        }
    }

    //     onChangedFilter: function () {
    //     },

    _onListRequest(data: any): void {
        let offset = data.offset;
        let count = data.count;
        this.loadOccurrences();
    }


    _onSetSubstitution(): void {

        console.log("substitution changed", this.inputSubstitution.get("value"));



        //return;



    }

    _onSaveUserSettingsError(error: any): void {
        //this._showLocationMessage(error.Message, "fa-times w3-text-red", 30000);
        this.occurrenceFilters.StandbyStop();
        alert(error.Message);
        this.StandbyStop();
    }

    _showLocationMessage(message: any, iconClass: any, durationMS?: any): void {
        this._hideLocationMessage();
        //console.log("location message", typeof (durationMS), durationMS);
        if (typeof (durationMS) != "number") {
            durationMS = 1500;
        }
        domAttr.set(this.locationMessageContent, "innerHTML", message);
        domClass.remove(this.locationMessageIcon);
        domClass.add(this.locationMessageIcon, "fa " + iconClass);
        domClass.remove(this.locationMessageContainer, "w3-hide");
        domStyle.set(this.locationMessageContainer, "opacity", 1);

        setTimeout(lang.hitch(this, "_hideLocationMessage"), durationMS);
    }

    _hideLocationMessage(): void {
        domStyle.set(this.locationMessageContainer, "opacity", 0);

        setTimeout(lang.hitch(this, function () {
            domClass.add(this.locationMessageContainer, "w3-hide");
        }), 3000);

    }



    _onClick_NewOccurrence(evt?: any): void {
        if (this.employee == null) {
            return;
        }

        //if (this.employee.Classname != "Employee") {
        //    return;
        //}
        this.showOccurrenceDialog();
    }

    showOccurrenceDialog(occurrenceGUID?: any, bReadOnly?: any, commentId?: any): any {

        if (true) {//(this.occurrenceDialog == null) {
            var occurrenceDialog = new OccurrenceFormDialog();
            this.occurrenceDialog = occurrenceDialog;

            occurrenceDialog.employee = this.employee;
            on(occurrenceDialog, "EntitySaved", lang.hitch(this, "_onEntitySaved", occurrenceDialog));
            on(occurrenceDialog, "OccurrenceFormClosed", lang.hitch(this, "_onOccurrenceFormClosed", occurrenceDialog));


            domConstruct.place(occurrenceDialog.domNode, this.modalDlg);

            occurrenceDialog.startup(occurrenceGUID, bReadOnly, commentId);
        }

        return occurrenceDialog;
    }


    _onEntitySaved(occurrenceDialog: any): void {

        var bIsNew = occurrenceDialog.occurrenceID == null;

        // total schiach: wenn der Dialog eine neue MEldung ist die an einer Hauptmeldung hängt, dann Abbruch
        if (occurrenceDialog.occurrenceForm?.mainOccurrence?.ID != null && bIsNew == true) {
            return;
        }

        this._onClick_Reload();
    }


    _onClick_Reload(): void {
        if (this._alternativeLoading != null) {
            this._alternativeLoading();
            return;
        }
        if (this._startupState != "ready") return;

        this._lastRequestParameters = null;
        this.applyFilters(0);

    }

    _onOccurrenceFormClosed(): void {

        if ((this.removeUrlParameter("view") as any) != false) {
        }

        if ((this.removeUrlParameter("create") as any) != false) {
        }

        if ((this.removeUrlParameter("qa") as any) != false) {
        }

        //this.siteActionReset();
    }


    showMessage(header: any, message: any, subtitle?: any, callback?: any): void {
        var dialog: any = new GenericDialog();

        if (typeof (subtitle) == "string") {
            dialog.set("subtitle", subtitle);
        } else {
            dialog.hideSubtitleNode();
        }

        this.genericDialog = dialog;
        domStyle.set(dialog.textNode, "height", "unset");

        dialog.set("header", header);
        dialog.set("content", message);
        dialog.set("callback", lang.hitch(this, "showMessageCallback", callback));

        dialog.set("ok", true);
        //dialog.set("cancel", true);

        dialog.show();
    }

    showMessageCallback(callback?: any): void {
        if (typeof (callback) == "function") {
            callback();
        }

        this.genericDialog = null;
    }

    _setupSubscriptions(): void {
        super._setupSubscriptions.apply(this, arguments as any);

        this._subscriptions.push((connect as any).subscribe("/Session/CheckForExistingSession", lang.hitch(this, "_sessionEstablished")));

    }
}
OccurrenceHome.prototype.declaredClass = 'WidgetCollection.JDM.Occurrence.OccurrenceHome';

export default mdsWidget(OccurrenceHome);
